import React, { useState, useEffect } from "react";
import { doGet, doPost,doPut } from "../services/api-service";
import {setAspekEdit} from "../actions"
import { useSelector,useDispatch } from "react-redux";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import Add from "@material-ui/icons/Add";
import Done from "@material-ui/icons/Done";
import Delete from "@material-ui/icons/Delete";
import SwapVert from "@material-ui/icons/SwapVert";
import MoreVert from "@material-ui/icons/MoreVert";
import Remove from "@material-ui/icons/Remove";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Select from "react-select";
import DebouncedTextField from "../components/DebouncedTextField";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem"
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Widgets from "@material-ui/icons/Widgets";
import NativeSelect from "@material-ui/core/NativeSelect";



const PaAspekCreateComponent = props => {
    const dispatch = useDispatch()
    const { classes } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const user = useSelector(state => state.user.user)
    const aspek_to_edit = useSelector(state => state.assessment.aspek_to_edit)
    const [openChildExt, setOpenChildExt] = React.useState(false);
    const [openChildSurvey, setOpenChildSurvey] = React.useState(false);
    const [groupOptions, setGroupOptions] = useState([])
    const [status, setStatus] = useState(true);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [note, setNote] = useState("");
    const [detailByHrd, setDetailByHrd] = useState(false);
    const [detailers, setDetailers] = useState([]);
    const [subAspeks, setSubAspeks] = useState([]);
    const [unsurs, setUnsurs] = useState([]);
    const [dataEmployees, setDataEmployees] = useState([]);
    const [masterOptions, setMasterOptions] = useState([])
    const [surveyOptions, setSurveyOptions] = useState([])
    const [selectedPaMaster, setSelectedPaMaster] = useState(null)
    const [aspekWeight, setAspekWeight] = useState(0)
    const [masterTotalWeight, setMasterTotalWeight] = useState(0)
    const [selectedunsurCode, setSelectedunsurCode] = useState("")

    useEffect(() => {
        getDataEmployees()
        getDataMaster()
        getDataGroup()
        getDataSurvey()
    }, [])
        
    const getDataSurvey = async() => {
        const params={}
        const response = await doGet("survey/select/current",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(survey=>({value:survey.id, label:survey.judul}))
            setSurveyOptions(dataForSelect)
        }

    }

    const getDataMaster = async () =>{
        const params={}
        const response = await doGet("pa/master/active",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(master=>({value:master.id, label: master.name}))
            setMasterOptions(dataForSelect)
        }

    }

    const getDataGroup = async () =>{
        const params={}
        const response = await doGet("pa/external/group/current",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(group=>({value:group, label:group}))
            setGroupOptions(dataForSelect)
        }
    }


    const getDataEmployees = async () => {
        if(dataEmployees.length<1){
            const response = await doGet("user", {});
            if (response&&response.data&&response.data.length > 0) {
                const dataForSelect = response.data.map(employee => ({
                    value: employee.emp_id,
                    label: employee.emp_name
                }));
                setDataEmployees(dataForSelect);
            }
        }
    };

    const toggleExternalDataMenu = (unsurCode,event) => {
        if(anchorEl)
        setAnchorEl(null);
        else
        setAnchorEl(event.currentTarget);
        setSelectedunsurCode(unsurCode)
      };

    const aspekWeightChange = (e) =>{
        setAspekWeight(e.target.value)
    }

    const masterOnChange = async(e) =>{
        setSelectedPaMaster(e)        
    }

    const cancel = () => {
        props.history.goBack();
    };
    const statusChange = e => {
        setStatus(!status);
    };

    const detailByHrdChange = e => {
        if(detailByHrd===false){
            getDataEmployees()
        }
        setDetailByHrd(!detailByHrd);
    };

    const detailersOnChange = e => {
        setDetailers(e);
    };

    const codeChange = e => {
        setCode(e.target.value);
    };
    const nameChange = value => {
        setName(value);
    };
    const noteChange = value => {
        setNote(value);
    };

    const addSubAspek = () => {
        const newSubAspek = {aspek_code:code, sub_aspek_code:`${code}.${subAspeks.length+1}`, sub_aspek_name:"", order:subAspeks.length+1}
        setSubAspeks([...subAspeks, newSubAspek])
    };

    const addUnsur = (sub_code) => {
        const unsursInSameSubAspek = unsurs.filter(u=>u.sub_aspek_code===sub_code)
        console.log(unsursInSameSubAspek);
        const newUnsur = {sub_aspek_code:sub_code,
            unsur_code:`${sub_code}.${unsursInSameSubAspek.length+1}`,
            unsur_name:"",
            order:unsurs.length+1,
            showCategory:false,
            external_data:null,
            is_optional:false,
            receiver_unsur_code:"",
            category_0_label:"",
            category_1_label:"",
            category_2_label:"",
            category_3_label:"",
            category_4_label:""}
        
        setUnsurs([...unsurs, newUnsur])
    };

    const deleteSubAspek = (sub_code) => {
        let indexSubAspek=1;
        const oldDeletedSubAspeks = subAspeks.filter(sub=>sub.sub_aspek_code!==sub_code) //delete subaspek
        let deletedUnsurs = unsurs.filter(u=>u.sub_aspek_code!==sub_code)//delete unsurs

        const newSubAspeks = oldDeletedSubAspeks.map(sub=>{
                                let indexUnsur=1;
                                const newSubAspekCode = `${sub.aspek_code}.${indexSubAspek}`;
                                let tobeReplaceUnsurs = deletedUnsurs.filter(u=>u.sub_aspek_code===sub.sub_aspek_code)
                                let otherUnsurs = deletedUnsurs.filter(u=>u.sub_aspek_code!==sub.sub_aspek_code)
                                const replacedUnsur = tobeReplaceUnsurs.map(u=>({...u, sub_aspek_code:newSubAspekCode, unsur_code:`${newSubAspekCode}.${indexUnsur++}`}))
                                deletedUnsurs = [...otherUnsurs, ...replacedUnsur]
                                return {...sub,sub_aspek_code:newSubAspekCode, order:indexSubAspek++}
                            })
        setSubAspeks(newSubAspeks)


        setUnsurs(deletedUnsurs)
    };

    const deleteUnsur = (unsur_code,sub_code) => {
        let index=1;
        const deletedUnsur = unsurs.filter(u=>u.unsur_code!==unsur_code)

        const tobeReplaceUnsur = deletedUnsur.filter(u=>u.sub_aspek_code===sub_code)
        const otherUnsur = deletedUnsur.filter(u=>u.sub_aspek_code!==sub_code)

        const replacedUnsur = tobeReplaceUnsur.map(u2=>{
                                return {...u2, unsur_code:`${sub_code}.${index}`, order:index++}
                            })
        setUnsurs([...otherUnsur,...replacedUnsur])
    };

    const toggleScoreLabel = (unsur_code) => {
        let selectedUnsur = unsurs.filter(u=>u.unsur_code===unsur_code)[0]
        const otherUnsurs = unsurs.filter(u=>u.unsur_code!==unsur_code)

        selectedUnsur= {...selectedUnsur, showCategory:!selectedUnsur.showCategory}

        const sorted = [...otherUnsurs, selectedUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    };

    const subAspekNameChange = (value,sub_code) => {
        let newSubAspek = subAspeks.filter(sub=>sub.sub_aspek_code === sub_code)[0]
        newSubAspek = {...newSubAspek, sub_aspek_name: value}

        const otherSubAspeks = subAspeks.filter(sub=>sub.sub_aspek_code !== sub_code)
        const sorted = [...otherSubAspeks, newSubAspek].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setSubAspeks(sorted)
    };

    const unsurNameChange = (value,unsur_code) => {
        let newUnsur = unsurs.filter(unsur=>unsur.unsur_code === unsur_code)[0]
        newUnsur = {...newUnsur, unsur_name: value}

        const otherUnsurs = unsurs.filter(unsur=>unsur.unsur_code !== unsur_code)
        const sorted = [...otherUnsurs, newUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    };

    const handleSelectBobotReceiver = (unsur_code,event) => {
        let newUnsur = unsurs.find(unsur=>unsur.unsur_code === unsur_code)
        newUnsur = {...newUnsur, receiver_unsur_code: event.target.value}

        const otherUnsurs = unsurs.filter(unsur=>unsur.unsur_code !== unsur_code)
        const sorted = [...otherUnsurs, newUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    };

    const categoryLabelChange = (value,unsur_code,score) => {
        let selectedUnsur = unsurs.filter(u=>u.unsur_code===unsur_code)[0]
        const otherUnsurs = unsurs.filter(u=>u.unsur_code!==unsur_code)

        switch(score){
            case 0:
                selectedUnsur= {...selectedUnsur, category_0_label:value}
            break;
            case 1:
                selectedUnsur= {...selectedUnsur, category_1_label:value}
            break;
            case 2:
                selectedUnsur= {...selectedUnsur, category_2_label:value}
            break;
            case 3:
                selectedUnsur= {...selectedUnsur, category_3_label:value}
            break;
            case 4:
                selectedUnsur= {...selectedUnsur, category_4_label:value}
            break;
        }


        const sorted = [...otherUnsurs, selectedUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)
    }


    const setThisCategoriesForAllUnsur = (unsur_code) => {
        let selectedUnsur = unsurs.filter(u=>u.unsur_code===unsur_code)[0]

        let UnsursSameSubaspek = unsurs.filter(u=>u.sub_aspek_code===selectedUnsur.sub_aspek_code)

        let UnsursOtherSubaspek = unsurs.filter(u=>u.sub_aspek_code!==selectedUnsur.sub_aspek_code)

        const newUnsurs = UnsursSameSubaspek.map(unsur=>({...unsur,
                                        category_0_label:selectedUnsur.category_0_label,
                                        category_1_label:selectedUnsur.category_1_label,
                                        category_2_label:selectedUnsur.category_2_label,
                                        category_3_label:selectedUnsur.category_3_label,
                                        category_4_label:selectedUnsur.category_4_label}))

        const sorted = [...UnsursOtherSubaspek, ...newUnsurs].sort((a, b) => (a.order > b.order) ? 1 : -1)
        setUnsurs(sorted)

    }

    const submit = async() => {
        let params = {
            code: code,
            name: name,
            note: note,
            status: status == true ? 1 : 0,
            creator: user.emp_id
        }

        if(detailByHrd){
            params = {
                ...params,
                is_custom:0,
                sub_aspeks:subAspeks,
                unsurs:unsurs,
            };
        }else{
            params = {
                ...params,
                is_custom:1,
                fixed_bobot:aspekWeight,
                master_id:selectedPaMaster?selectedPaMaster.value:null,
                detailers:detailers.map(user=>(user.value)),
            };
        }
        
        if(!aspek_to_edit){            
            await doPost("pa/aspek", params, "save aspek");
        }else{
            const paramsEdit = {
                ...params,
                id:aspek_to_edit.id,
                updated_by: user.emp_id
            };
            await doPut("pa/aspek", paramsEdit, "save aspek");
            dispatch(setAspekEdit())
        }
        props.history.goBack();
    };

    const setExternalData = (ex_data) =>{
        if(ex_data==="optional" || ex_data==="mandatory"){
            let newUnsur = unsurs.find(unsur=>unsur.unsur_code === selectedunsurCode)
            newUnsur = {...newUnsur, is_optional: ex_data==="optional", external_data:null}

            const otherUnsurs = unsurs.filter(unsur=>unsur.unsur_code !== selectedunsurCode)
            const sorted = [...otherUnsurs, newUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
            setUnsurs(sorted)
        }else{
            let newUnsur = unsurs.find(unsur=>unsur.unsur_code === selectedunsurCode)
            newUnsur = {...newUnsur, external_data: ex_data, is_optional:false}

            const otherUnsurs = unsurs.filter(unsur=>unsur.unsur_code !== selectedunsurCode)
            const sorted = [...otherUnsurs, newUnsur].sort((a, b) => (a.order > b.order) ? 1 : -1)
            setUnsurs(sorted)
        }

        setAnchorEl(null)
    }


    const create = async () => {
        


    };

    const OpenCloseCategory = ({open, unsur_code})=> {
        if(open){
            return (<Tooltip title="Hide score categories">
                        <IconButton aria-label="Add Score Categories" onClick={()=>toggleScoreLabel(unsur_code)}>
                            <Remove/>
                        </IconButton>
                    </Tooltip>)
        }

        return (<Tooltip title="Show score categories">
                        <IconButton aria-label="Add Score Categories" onClick={()=>toggleScoreLabel(unsur_code)}>
                            <Add/>
                        </IconButton>
                    </Tooltip>)
    }

    const getUnsurInSubAspek= (sub_aspek_code) => {
        return unsurs.filter(u=>u.sub_aspek_code===sub_aspek_code)
    }

   
    const getAspekDetail= async (aspek) => {
        const params = {};
        const response = await doGet("pa/aspek/"+aspek.id, params);
        if(response && response.data){
            let aspek = response.data
            let subAspekOrder=0
            let unsurOrder=0

            setCode(aspek.code)
            setName(aspek.name)
            setNote(aspek.note)
            setDetailByHrd(aspek.is_custom===0)
            
            if(aspek.master){
                setSelectedPaMaster({
                    ...aspek.master,
                    label: aspek.master.name,
                    value: aspek.master.id
                })
            }
            
            if(aspek.detailers){
                setDetailers(
                    aspek.detailers.map(det=>({
                        value:det.emp_id,
                        label:det.emp_name
                    }))
                )
            }
            
            setStatus(aspek.status_code===1)
            setSubAspeks(aspek.sub_aspeks.map(sub=>({
                id:sub.id,
                aspek_code:aspek.code, 
                sub_aspek_code:sub.code, 
                sub_aspek_name:sub.name, 
                order:subAspekOrder++
            })))

            setUnsurs(aspek.unsurs.map(uns=>({
                id:uns.id,
                sub_aspek_code:uns.sub_aspek.code,
                unsur_code:uns.code,
                unsur_name:uns.name,
                order:unsurOrder++,
                showCategory:true,
                external_data:uns.external_data,
                is_optional:uns.is_optional===1,
                receiver_unsur_code:uns.receiver_unsur_code,
                category_0_label:uns.category_0_label,
                category_1_label:uns.category_1_label,
                category_2_label:uns.category_2_label,
                category_3_label:uns.category_3_label,
                category_4_label:uns.category_4_label
            })))
        }

    }


    useEffect(() => {
        if(aspek_to_edit){
            getAspekDetail(aspek_to_edit)
        }
    }, [aspek_to_edit])

    useEffect(() => {
        const getWeight = async()=>{
            const respose = await doGet("pa/master/weight/"+selectedPaMaster.value,{})
            setMasterTotalWeight(respose.data.master_weight)
            setAspekWeight(100-parseInt(respose.data.master_weight))
        }

        if(selectedPaMaster){
            getWeight()
        }
        
    }, [selectedPaMaster])
    


    const title = aspek_to_edit ? "Edit Aspek" : "Create New Aspek"
    return (
        <Grid container direction="column">
            <Grid container>
                <Grid container>
                    <Typography
                        variant="h6"
                        gutterBottom
                        className="animated slideInLeft"
                    >
                        {title}
                    </Typography>
                </Grid>
                <Grid container spacing={8} >
                    <Grid item xs={1}>
                        <TextField
                            id="Code"
                            label="Code"
                            value={code}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                            onChange={codeChange}
                        />
                    </Grid>

                    <Grid item xs={6}>
                    <DebouncedTextField
                        id="Name"
                        label="Name"
                        key_id_1="name"
                        value={name}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={nameChange}
                    />
                    </Grid>
                    <Grid item xs={2}>
                    <DebouncedTextField
                        id="note"
                        label="note"
                        key_id_1="note"
                        value={note}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={noteChange}
                    />
                    </Grid>
                
                    <Grid item xs={2} container alignItems="center">
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={detailByHrd}
                                    onChange={detailByHrdChange}
                                    color="primary"
                                    inputProps={{
                                        "aria-label": "primary checkbox"
                                    }}
                                />
                            }
                            label={detailByHrd ? "Detail By HRD" : "Detail By Leader (custom)"}
                        />
                    </Grid>
                    
                    <Grid item xs={1} container justify="center" alignContent="center">
                        {   detailByHrd===true &&
                            <Tooltip title="Add sub aspek">
                                <IconButton aria-label="add sub aspek" onClick={addSubAspek}>
                                    <Add/>
                                </IconButton>
                            </Tooltip>
                        }
                    </Grid>
                </Grid>

                
                    <Grid container>
                        <Grid item xs={12} container>
                        {
                            subAspeks.map(sub=>(
                                <Grid container spacing={8} className={classes.sub_aspek_row}>
                                    <Grid item xs={2}>
                                        <TextField
                                            id="Sub Aspek Code"
                                            label="Sub Aspek Code"
                                            value={sub.sub_aspek_code}
                                            margin="dense"
                                            variant="outlined"
                                            fullWidth
                                            style={{backgroundColor:"white", borderRadius:4}}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <DebouncedTextField
                                            label="Sub Aspek Name"
                                            value={sub.sub_aspek_name}
                                            key_id_1 = {sub.sub_aspek_code}
                                            margin="dense"
                                            variant="outlined"
                                            fullWidth
                                            style={{backgroundColor:"white", borderRadius:4}}
                                            onChange={subAspekNameChange}
                                        />

                                    </Grid>
                                    <Grid item xs={2} container justify="center" alignContent="center">
                                        <Tooltip title="Delete Sub Aspek">
                                            <IconButton aria-label="delete" onClick={()=>deleteSubAspek(sub.sub_aspek_code)}>
                                            <Delete/>
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Add Unsur">
                                            <IconButton aria-label="delete" onClick={()=>addUnsur(sub.sub_aspek_code)}>
                                                <Add/>
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                    <Grid container className={classes.unsur_container}>
                                    {
                                        getUnsurInSubAspek(sub.sub_aspek_code).map(unsur=>(
                                            <Grid item xs={12} container spacing={8} className={classes.unsur_row}>
                                                <Grid item xs={2}>
                                                    <TextField
                                                    
                                                        id="Unsur Code"
                                                        label="Unsur Code"
                                                        value={unsur.unsur_code}
                                                        margin="dense"
                                                        variant="outlined"
                                                        fullWidth
                                                        style={{backgroundColor:"white", borderRadius:4}}
                                                    />

                                                </Grid>
                                                <Grid item xs={6}>
                                                    <DebouncedTextField
                                                        id="Unsur Name"
                                                        label="Unsur Name"
                                                        key_id_1={unsur.unsur_code}
                                                        value={unsur.unsur_name}
                                                        margin="dense"
                                                        variant="outlined"
                                                        fullWidth
                                                        onChange={unsurNameChange}
                                                        style={{backgroundColor:"white", borderRadius:4}}
                                                        multiline
                                                        rows={6}
                                                    />

                                                </Grid>

                                                <Grid item xs={4} container alignItems="center">
                                                    <Tooltip title="Delete Unsur">
                                                        <IconButton size="small" aria-label="delete" onClick={()=>deleteUnsur(unsur.unsur_code,unsur.sub_aspek_code)}>
                                                            <Delete fontSize="small"/>
                                                        </IconButton>
                                                    </Tooltip>

                                                    <OpenCloseCategory open={unsur.showCategory} unsur_code={unsur.unsur_code}/>

                                                    {!unsur.external_data && !unsur.is_optional &&
                                                    <IconButton  size="small" onClick={(event)=>toggleExternalDataMenu(unsur.unsur_code,event)} >
                                                            <MoreVert fontSize="small"/>
                                                    </IconButton>
                                                    }

                                                    {unsur.external_data && !unsur.is_optional &&
                                                    <Tooltip title={unsur.external_data}>
                                                        <IconButton  size="small" onClick={(event)=>toggleExternalDataMenu(unsur.unsur_code,event)} >
                                                                <Widgets fontSize="small" style={{color:"red"}}/>
                                                        </IconButton>
                                                    </Tooltip>
                                                    }

                                                    {

                                                        unsur.is_optional &&
                                                        <>
                                                        <Typography type="body2" onClick={(event)=>toggleExternalDataMenu(unsur.unsur_code,event)} className={classes.pointer}>optional</Typography>

                                                        <NativeSelect
                                                        value={unsur.receiver_unsur_code}
                                                        onChange={(event)=>handleSelectBobotReceiver(unsur.unsur_code,event)}
                                                        inputProps={{
                                                            name: "age",
                                                            id: "age-native-helper",
                                                        }}
                                                        style={{marginLeft: 8}}
                                                        >
                                                        <option value="">bobot receiver</option>
                                                        {
                                                            getUnsurInSubAspek(sub.sub_aspek_code)
                                                            .filter(unsr=>unsr.unsur_code!==unsur.unsur_code)
                                                            .map(fltUnsur=>(
                                                            <option value={fltUnsur.unsur_code}>{fltUnsur.unsur_code}</option>
                                                            ))
                                                        }

                                                        </NativeSelect>
                                                        </>
                                                    }


                                                </Grid>
                                                {   unsur.showCategory &&
                                                    <Grid container className={classes.category_container}>
                                                        <Grid item xs={12} container spacing={8} className={classes.category_row}>
                                                            <Grid item container justify="center" alignContent="center" className={classes.side_row_button}>
                                                                <Tooltip title="Same for all">
                                                                    <IconButton aria-label="delete" onClick={()=>setThisCategoriesForAllUnsur(unsur.unsur_code)}>
                                                                        <SwapVert/>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                            <Grid item className={classes.category_field}>
                                                                <DebouncedTextField
                                                                        id="score4"
                                                                        label="scored 4 means"
                                                                        value={unsur.category_4_label}
                                                                        key_id_1={unsur.unsur_code}
                                                                        key_id_2={4}
                                                                        margin="dense"
                                                                        placeholder="meaning if the score is 4"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        onChange={categoryLabelChange}
                                                                        style={{backgroundColor:"white", borderRadius:4}}
                                                                    />
                                                            </Grid>
                                                            <Grid item className={classes.category_field}>
                                                                <DebouncedTextField
                                                                    id="score3"
                                                                    label="scored 3 means"
                                                                    value={unsur.category_3_label}
                                                                    key_id_1={unsur.unsur_code}
                                                                    key_id_2={3}
                                                                    placeholder="meaning if the score is 3"
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    onChange={categoryLabelChange}
                                                                    style={{backgroundColor:"white", borderRadius:4}}
                                                                />
                                                            </Grid>
                                                            <Grid item className={classes.category_field}>
                                                                <DebouncedTextField
                                                                    id="score2"
                                                                    label="scored 2 means"
                                                                    value={unsur.category_2_label}
                                                                    key_id_1={unsur.unsur_code}
                                                                    key_id_2={2}
                                                                    placeholder="meaning if the score is 2"
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    onChange={categoryLabelChange}
                                                                    style={{backgroundColor:"white", borderRadius:4}}
                                                                />
                                                            </Grid>
                                                            <Grid item className={classes.category_field}>
                                                                <DebouncedTextField
                                                                    id="score1"
                                                                    label="scored 1 means"
                                                                    value={unsur.category_1_label}
                                                                    key_id_1={unsur.unsur_code}
                                                                    key_id_2={1}
                                                                    placeholder="meaning if the score is 1"
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    onChange={categoryLabelChange}
                                                                    style={{backgroundColor:"white", borderRadius:4}}
                                                                />
                                                            </Grid>
                                                            <Grid item className={classes.category_field}>
                                                                <DebouncedTextField
                                                                    id="score0"
                                                                    label="scored 0 means"
                                                                    value={unsur.category_0_label}
                                                                    key_id_1={unsur.unsur_code}
                                                                    key_id_2={0}
                                                                    placeholder="meaning if the score is 0"
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    onChange={categoryLabelChange}
                                                                    style={{backgroundColor:"white", borderRadius:4}}
                                                                />
                                                            </Grid>

                                                        </Grid>
                                                    </Grid>
                                                }


                                            </Grid>
                                        ))
                                    }
                                    </Grid>
                                </Grid>
                            ))
                        }
                    </Grid>

                    </Grid>
                

                { detailByHrd===false &&
                <>
                <Grid spacing={8} container className={classes.marginTops}>
                    <Grid item xs={6} >
                            <Select
                                options={masterOptions}
                                value={selectedPaMaster}
                                onChange={masterOnChange}
                                placeholder="Select PA Master"
                                />
                    </Grid>
                <Grid item xs={3} container alignContent="center">weight selected master : {masterTotalWeight} %</Grid>
                <Grid spacing={8} item xs={3} container alignItems="center" alignContent="center">
                    <Grid item>weight of this aspek</Grid>
                    <Grid item>
                    <TextField
                        type="number"
                        margin="dense"
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            min:
                                "0",
                            max:
                                `${100-masterTotalWeight}`,
                            step:
                                "1"
                        }}
                        onChange={aspekWeightChange}
                        value={
                            aspekWeight
                        }
                    />

                    </Grid>
                    %
                </Grid>
                </Grid>
                <Grid container className={classes.marginTops}>
                    <Grid item xs={12}>
                        <Select
                        isMulti
                        name="detailer"
                        value={detailers}
                        onChange={detailersOnChange}
                        options={dataEmployees}
                        placeholder="Select Leaders"/>
                    </Grid>
                </Grid>
                </>
                }


                <Grid container>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={status}
                                onChange={statusChange}
                                color="primary"
                                inputProps={{
                                    "aria-label": "primary checkbox"
                                }}
                            />
                        }
                        label={status ? "active" : "inactive"}
                    />
                </Grid>
            </Grid>
            <Grid
                justify="flex-end"
                container
                className={classes.addAction}
                spacing={8}
            >
                <Grid item>
                    <Button variant="outlined" onClick={cancel}>
                        cancel
                    </Button>
                </Grid>

                <Grid item>
                    <Button
                        onClick={submit}
                        color="primary"
                        variant="contained"
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={toggleExternalDataMenu}
                anchorOrigin={{
                vertical: "center",
                horizontal: "left",
                }}
                transformOrigin={{
                vertical: "center",
                horizontal: "right",
                }}
            >
                <Grid container style={{width:500, height:500, overflow:"scroll"}}>
                    <Grid item xs={12}><MenuItem onClick={()=>setExternalData("optional")}>Optional</MenuItem></Grid>
                    <Grid item xs={12}><MenuItem onClick={()=>setExternalData("mandatory")}>Mandatory</MenuItem></Grid>
                    <Grid item xs={12}><MenuItem onClick={()=>setExternalData(null)}>No External Data</MenuItem></Grid>
                    <Grid item xs={12}><MenuItem onClick={()=>setExternalData("hris_ijin")}>Data HRIS Ijin</MenuItem></Grid>
                    <Grid item xs={12}><MenuItem onClick={()=>setExternalData("hris_absen")}>Data HRIS Absen</MenuItem></Grid>
                    <Grid item xs={12}>
                        <MenuItem onClick={()=>setOpenChildExt(!openChildExt)}>
                            Data Input by HRD
                            {openChildExt ? <ExpandLess /> : <ExpandMore />}
                        </MenuItem>
                    </Grid>
                    <Grid item xs={12}>
                        <Collapse in={openChildExt} timeout="auto" unmountOnExit>
                            {groupOptions.map(group=>(
                                <MenuItem onClick={()=>setExternalData(group.value)}>{group.value}</MenuItem>
                            ))
                            }
                        </Collapse>
                    </Grid>
                    <Grid item xs={12}>
                        <MenuItem onClick={()=>setOpenChildSurvey(!openChildSurvey)}>
                            Data Survey
                            {openChildSurvey ? <ExpandLess /> : <ExpandMore />}
                        </MenuItem>
                    </Grid>
                    <Grid item xs={12}>
                        <Collapse in={openChildSurvey} timeout="auto" unmountOnExit>
                            {surveyOptions.map(survey=>(
                                <MenuItem onClick={()=>setExternalData("survey-"+survey.value)}>{survey.label}</MenuItem>
                            ))
                            }
                        </Collapse>
                    </Grid>

                </Grid>

            </Popover>

        </Grid>
    );
};



const styles = theme => ({
    marginTops: {
        marginTop: 10
    },
    container: {
        marginTop: -16,
        marginLeft: 5
    },
    marginOver: {
        marginTop: -25
    },
    score: {
        maxWidth: 50
    },
    unsur_row:{
        padding:"0 0px 15px 10px",
        backgroundColor:"#e4ffe4",
        borderRadius:4
    },
    sub_aspek_row:{
        marginTop:20,
        backgroundColor:"#c5e7ff",
        borderRadius:4
    },
    unsur_container:{
        margin:10
    },
    category_container:{
        marginLeft:15,
    },
    category_row:{
        paddingRight:5,
        backgroundColor:"#c9bfff",
        borderRadius:4
    },
    category_field:{
        flex:10
    },
    side_row_button:{
        flex:1
    },
    pointer:{
        cursor: "pointer",
        color: "red"
    }
});


export default withRouter(withStyles(styles)(PaAspekCreateComponent));
